import React from 'react';
import ReactDOM from 'react-dom';

import { Slide, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import { UxContext } from './UxContext';

const SnackBar = () => {
    const { showSnackbar, handleSnackbar, snackBarData } = React.useContext(UxContext)!;

    if (showSnackbar) {
        return ReactDOM.createPortal(
            <Snackbar
                open={showSnackbar}
                onClose={() => handleSnackbar()}
                autoHideDuration={4000}
                TransitionComponent={Slide}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <MuiAlert elevation={6} variant="filled" severity={snackBarData.severity as 'success' | 'error' | 'warning' | 'info'}>
                    {snackBarData.message}
                </MuiAlert>
            </Snackbar>,
            document.querySelector('#snackbar') as Element
        );
    }

    return null;
};

export default SnackBar;
